export const PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT = 'aud_desktop_bx775_saved_search_favorites_merge';

export const MORTGAGE_SHORT_FORM_EXPERIMENT = 'b2c_txn1366_short_form_web';

export const EXPERIMENTS = [PERS_SAVED_SEARCH_FAVORITES_MERGE_EXPERIMENT, MORTGAGE_SHORT_FORM_EXPERIMENT];
